import { useState, useEffect } from "react";
import "./Menu.scss";
import $ from "jquery";
import {
  MAIN_MENU,
  SUSTAINABILITY_23,
  SUSTAINABILITY_24,
  SUSTAINABILITY_25,
} from "../MenuList";
import { useNavigate, useLocation } from "react-router-dom";
const iconPath = process.env.PUBLIC_URL + "/assets/docs/";

export default function Menu(props) {
  const [show, setShow] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  const [listOfMenu, setListOfMenu] = useState(MAIN_MENU);

  useEffect(() => {
    if (
      location.pathname == "/sustainability-23" ||
      location.pathname == "/event-agenda-23" ||
      location.pathname == "/support-23"
    ) {
      setListOfMenu(SUSTAINABILITY_23);
    } else if (
      location.pathname == "/sustainability-24" ||
      location.pathname == "/support-24"
    ) {
      setListOfMenu(SUSTAINABILITY_24);
    } else if (
      location.pathname == "/sustainability-25" ||
      location.pathname == "/support-25"
    ) {
      setListOfMenu(SUSTAINABILITY_25);
    } else {
      setListOfMenu(MAIN_MENU);
    }
  });

  const navigateMbrdi = (index, links) => {
    navigate(links.path);
    props.toggle();
  };

  const navigateTo = (path, e) => {
    if (path !== "") {
      setShow(false);
    }

    if (path !== location && path !== "") {
      navigate(path);
    }
  };

  const toggleMenu = (index, links) => {
    setIsActive(true);
    let menus = listOfMenu;
    if (menus[index]["isActive"]) {
      $("#" + index + "subLinks").slideUp("slow");
    } else {
      $("#" + index + "subLinks").slideDown("slow");
    }
    menus[index]["isActive"] = !menus[index]["isActive"];
    setListOfMenu(menus);
  };

  const toggleSubMenu = (index, subIndex) => {
    let menus = listOfMenu;
    if (menus[index]["subMenu"][subIndex]["isActive"]) {
      $("#" + subIndex + "subLinks1").slideUp("slow");
    } else {
      $("#" + subIndex + "subLinks1").slideDown("slow");
    }
    menus[index]["subMenu"][subIndex]["isActive"] =
      !menus[index]["subMenu"][subIndex]["isActive"];
    setListOfMenu(menus);
  };

  const navigateLink = (link) => {
    if (link != location.pathname) {
      navigate(link);
    }
    props.toggle();
  };

  useEffect(() => {}, []);

  function MenuLink({ link, iconPath, navigateTo }) {
    const externalLinks = [
      "Annual Return FY21-22",
      "Annual Return FY22-23",
      "Annual Return FY23-24",
      "Annual Return FY24-25",
      "AGM Notice FY23-24",
      "AGM Notice FY22-23",
      "Vehicle Privacy Policy",
    ];

    const isExternal = externalLinks.includes(link.title);

    const getExternalHref = (title) => {
      switch (title) {
        case "Annual Return FY21-22":
          return `${iconPath}Annual-Return_1.pdf`;
        case "Annual Return FY22-23":
          return `${iconPath}Annual-Return_2.pdf`;
        case "Annual Return FY23-24":
          return `${iconPath}Annual-Return_3.pdf`;
        case "Annual Return FY24-25":
          return `${iconPath}Annual-Return_4.pdf`;
        case "AGM Notice FY23-24":
          return `${iconPath}AGM_Notice_FY2023-24.pdf`;
        case "AGM Notice FY22-23":
          return `${iconPath}AGM_Notice_FY2022-23.pdf`;
        case "Vehicle Privacy Policy":
          return "https://mbrdi.co.in/#/vehicle-privacy-policy";
        default:
          return "#";
      }
    };

    if (isExternal) {
      return (
        <a
          className="primary-link"
          target="_blank"
          rel="noopener noreferrer"
          href={getExternalHref(link.title)}
        >
          <span className="sub-title">{link.title}</span>
        </a>
      );
    } else {
      return (
        <a
          href="#"
          className="primary-link"
          onClick={(e) => {
            e.preventDefault();
            if (link.path) navigateTo(link.path, e);
          }}
        >
          <span className="sub-title">{link.title}</span>
        </a>
      );
    }
  }

  return (
    <div className={isActive ? "t" : "mobile-menu"} id="mobile-menu">
      <ul className="links">
        {listOfMenu.map((links, index) => (
          <li>
            {links["title"] === "The MBRDI Experience" ? (
              <div className="mbrdi-content">
                <a
                  class={
                    links["isActive"] ? "primary-link active" : "primary-link"
                  }
                  onClick={() => navigateMbrdi(index, links)}
                >
                  {links["title"]}
                </a>
                <span
                  id="menu-toggle-span"
                  className="menu-toggle-span"
                  style={{ fontSize: 18, padding: 8 }}
                  onClick={() => toggleMenu(index, links)}
                >
                  {links["isActive"] ? "-" : "+"}{" "}
                </span>
              </div>
            ) : (
              links["subMenu"] &&
              links["title"] !== "The MBRDI Experience" && (
                <a
                  class={
                    links["isActive"] ? "primary-link active" : "primary-link"
                  }
                  onClick={() => toggleMenu(index, links)}
                >
                  {links["title"]}
                  <span className="menu-toggle">
                    {links["isActive"] ? "-" : "+"}{" "}
                  </span>
                </a>
              )
            )}
            {!links["subMenu"] && (
              <a
                // target="new"
                // href={links.link !== "" && `${iconPath + links.link}`}
                target={links.link.startsWith("http") ? "_blank" : "new"}
                href={
                  links.link !== ""
                    ? links.link.startsWith("http")
                      ? links.link
                      : iconPath + links.link
                    : undefined
                }
                class="primary-link"
                onClick={() => links.path != "" && navigateLink(links.path)}
              >
                {links["title"]}
              </a>
            )}

            {links["subMenu"] && (
              <ul id={index + "subLinks"} className="subLinks">
                {links["subMenu"].map((subLinks, subIndex) => (
                  <li>
                    {subLinks["subMenu"] && (
                      <a onClick={() => toggleSubMenu(index, subIndex)}>
                        {subLinks["title"]}
                        <span className="menu-toggle">
                          {subLinks["isActive"] ? "-" : "+"}{" "}
                        </span>
                      </a>
                    )}
                    {!subLinks["subMenu"] && (
                      <a onClick={() => navigateLink(subLinks.path)}>
                        {subLinks["title"]}
                      </a>
                    )}
                    {subLinks["subMenu"] && (
                      <ul id={subIndex + "subLinks1"} className="subLinks">
                        {subLinks["subMenu"].map((links) => (
                          <li>
                            <MenuLink
                              link={links}
                              iconPath={iconPath}
                              navigateTo={navigateTo}
                            />
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
